import React, { useEffect } from 'react';
import styles from './AboutPage.module.css'; // Import module-specific styles
import MainLayout from '../../Layout/MainLayout';
import image1 from '../../Assets/About/Image1.png'; // Import asset images and icons
import image2 from '../../Assets/About/Image2.png';
import image3 from '../../Assets/About/Image3.png';
import icon1 from '../../Assets/About/Icon1.svg';
import icon2 from '../../Assets/About/Icon2.svg';
import icon3 from '../../Assets/About/Icon3.svg';
import icon4 from '../../Assets/About/Icon4.svg';
import icon5 from '../../Assets/About/Icon5.svg';
import icon6 from '../../Assets/About/Icon6.svg';
import image4 from '../../Assets/About/Image4.png';
import image5 from '../../Assets/About/Image5.png';
import image6 from '../../Assets/About/Image6.png';
import image7 from '../../Assets/About/Image7.png';
import image8 from '../../Assets/About/Image8.png';
import image9 from '../../Assets/About/Image9.png';

const AboutPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top of the page on component mount
    }, []);

    return (
        <MainLayout> {/* Wrapper component for main layout structure */}
            <div className={styles.about}>
                {/* Section 1 */}
                <div className={styles.about1}>
                    <h1>We are proud of our products</h1>
                    <p className="pLarge">
                        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
                    </p>
                    <div className={styles.about1Bottom}>
                        <img src={image1} alt="Product showcase 1" />
                        <img src={image2} alt="Product showcase 2" />
                        <img src={image3} alt="Product showcase 3" />
                    </div>
                </div>

                {/* Section 2 */}
                <div className={styles.about2}>
                    <h4>About Us</h4>
                    <h2>We’re a team of data analysts</h2>
                    <p className="pLarge">
                        Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
                    </p>
                </div>

                {/* Section 3 */}
                <div className={styles.about3}>
                    <div className={styles.about3Item}>
                        <h4>Our Goals</h4>
                        <h2>To upscale your business to the next level</h2>
                        <p>
                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
                        </p>
                    </div>
                    <div className={styles.about3Item}>
                        <h4>Our Vision</h4>
                        <h2>To provide solutions for growing companies</h2>
                        <p>
                            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
                        </p>
                    </div>
                </div>

                {/* Section 4 */}
                <div className={styles.about4}>
                    <div className={styles.about4Top}>
                        <h2>Our corporate values</h2>
                        <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
                    </div>
                    <div className={styles.about4Bottom}>
                        <div className={styles.about4BRow}>
                            <div className={styles.about4Item}>
                                <img src={icon1} alt="Best in Class icon" />
                                <h4>Best in Class</h4>
                                <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
                            </div>
                            <div className={styles.about4Item}>
                                <img src={icon2} alt="Authenticity icon" />
                                <h4>Authenticity</h4>
                                <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
                            </div>
                            <div className={styles.about4Item}>
                                <img src={icon3} alt="Email Support icon" />
                                <h4>Email Support</h4>
                                <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
                            </div>
                        </div>
                        <div className={styles.about4BRow}>
                            <div className={styles.about4Item}>
                                <img src={icon4} alt="Discounts Available icon" />
                                <h4>Discounts Available</h4>
                                <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
                            </div>
                            <div className={styles.about4Item}>
                                <img src={icon5} alt="Powerful Marketing icon" />
                                <h4>Powerful Marketing</h4>
                                <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
                            </div>
                            <div className={styles.about4Item}>
                                <img src={icon6} alt="Inventory Management icon" />
                                <h4>Inventory management</h4>
                                <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy.</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section 5 */}
                <div className={styles.about5}>
                    <div className={styles.about5Left}>
                        <h2>Our talented Team</h2>
                        <p className="pLarge">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore.</p>
                    </div>
                    <div className={styles.about5Right}>
                        <div className={styles.about5RRow}>
                            <div className={styles.about5RItem}>
                                <img src={image4} alt="Blake Matthews, CEO & Co-Founder" />
                                <h4>Blake Matthews</h4>
                                <p>CEO & Co-Founder</p>
                            </div>
                            <div className={styles.about5RItem}>
                                <img src={image5} alt="Jack Newman, CTO" />
                                <h4>Jack Newman</h4>
                                <p>CTO</p>
                            </div>
                            <div className={styles.about5RItem}>
                                <img src={image6} alt="Sarinia Martins, Marketing" />
                                <h4>Sarinia Martins</h4>
                                <p>Marketing</p>
                            </div>
                        </div>
                        <div className={styles.about5RRow}>
                            <div className={styles.about5RItem}>
                                <img src={image7} alt="Spencer Wright, Project Management" />
                                <h4>Spencer Wright</h4>
                                <p>Project management</p>
                            </div>
                            <div className={styles.about5RItem}>
                                <img src={image8} alt="Caroline Ming, Sales" />
                                <h4>Caroline Ming</h4>
                                <p>Sales</p>
                            </div>
                            <div className={styles.about5RItem}>
                                <img src={image9} alt="Anna Mills, Design Lead" />
                                <h4>Anna Mills</h4>
                                <p>Design lead</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
}

export default AboutPage;
